import { IoCloseOutline, IoSearchOutline } from "react-icons/io5";
import { IconButton } from ".";
import { cn } from "../../utils/lib";

interface SearchInputProps {
    value: string;
    onChange: (value: string) => void;
    onSearch?: () => void;
    onCancel?: () => void;
    placeholder?: string;
    size?: "sm" | "md" | "lg";
    type?: "text" | "number";
}

const SearchInput = ({
    placeholder = "Search...",
    onChange,
    value,
    onSearch,
    onCancel,
    size = "md",
    type = "text",
}: SearchInputProps) => {
    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onSearch && onSearch();
        }

        if (type === "number") {
            if (
                e?.key === "ArrowUp" ||
                e?.key === "ArrowDown" ||
                ["e", "E", "+", "-"].includes(e?.key) ||
                e?.key === "."
            ) {
                e?.preventDefault();
            }
        }
    };
    const SIZE = {
        sm: "px-1.5 py-1 2xl:px-2 2xl:py-1.5",
        md: "px-2 py-1.5 2xl:px-2.5 py-2",
        lg: "px-2.5 py-2 2xl:px-3 2xl:py-2.5",
    };

    const ICON_SIZE = {
        sm: "p-0.5",
        md: "p-1",
        lg: "p-1.5",
    };
    const icon = {
        sm: "h-3 w-3",
        md: "h-3.5 w-3.5",
        lg: "h-4 w-4",
    };

    return (
        <div className="relative flex w-60 items-center rounded-md border border-gray-300 bg-white px-1.5 text-[12px] focus-within:border-primary focus-within:ring-1 focus-within:ring-primary 2xl:w-72 2xl:text-xs">
            {!onSearch && (
                <IoSearchOutline className={cn("ml-1 h-3 text-gray-400", icon[size])} />
            )}
            <input
                type={type}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className={cn(
                    "flex-grow bg-transparent text-[12px] outline-none focus:outline-none",
                    SIZE[size],
                )}
                placeholder={placeholder}
                onKeyDown={onKeyDown}
                autoComplete="off"
            />
            <div className="flex items-center gap-1">
                {value && value.length > 0 && (
                    <IconButton
                        icon={<IoCloseOutline  className={cn(icon[size])} />}
                        onClick={onCancel}
                        className={cn(ICON_SIZE[size])}
                        color="red"
                    />
                )}
                {onSearch && (
                    <IconButton
                        icon={<IoSearchOutline className={cn(icon[size])} />}
                        onClick={onSearch}
                        className={cn(ICON_SIZE[size])}
                    />
                )}
            </div>
            {value && (
                <span className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-green-500" />
            )}
        </div>
    );
};

export { SearchInput };

